import styled from 'styled-components'

import DragIconStyled from './DragIconStyled'

const DraggableStyled = styled.div`
  position: relative;

  &:hover ${DragIconStyled} {
    display: flex;
  }
`

export default DraggableStyled
